import {
  Component,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
  OnDestroy,
  Output,
  EventEmitter,
  LOCALE_ID
} from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CompraFotosService } from '../core/services/compraFotos.service';
import { BehaviorSubject, debounceTime, Subscription } from 'rxjs';
import { CompraFotoReservationService } from "../core/services/CompraFotoReservationService";
import { takeUntil } from "rxjs/operators";
import { dniValidator, telefonoValidator, codigoPostalValidator  } from "@lib/utils/compra-foto-utils";
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';

registerLocaleData(localeEs);

@Component({
  selector: 'fotos-form-foto',
  templateUrl: './form-foto.component.html',
  styleUrls: ['./form-foto.component.scss'],
  providers: [{ provide: LOCALE_ID, useValue: 'es' }]
})
export class FormFotoComponent implements OnInit, OnChanges, OnDestroy {

  @Input() numeroEntradas: number = 0;
  @Input() compradorForm!: FormGroup;

  compradorData: any = {};
  private subscription!: Subscription;

  @Input() formulario!: FormGroup;

  fechaSeleccionada: Date = new Date();
  horaSeleccionada: string = '';
  submitClicked = false;

  resumenEntradas$ = new BehaviorSubject<any>(this.calcularResumen());
  @Output() resumenChanged = new EventEmitter<any>();

  @Input() fechaPartido: Date | null = null;

  constructor(private compraFotoService: CompraFotosService, private fb: FormBuilder, private reservationService: CompraFotoReservationService) {
  }

  ngOnInit(): void {
    this.formulario.valueChanges.subscribe(() => {
      this.reservationService.registerActivity();
    });

    const entradasArray = this.formulario.get('entradas') as FormArray;
    if (this.numeroEntradas > 0 && entradasArray.length === 0) {
      this.crearFormularios();
    }

    if (this.compradorForm) {
      this.subscription = this.compradorForm.valueChanges.subscribe(value => {
        this.compradorData = value;
      });
      this.compradorData = this.compradorForm.value;
    }

    const resumenInicial = this.calcularResumen();
    this.resumenChanged.emit(resumenInicial);

    this.formulario.valueChanges
      .pipe(debounceTime(100))
      .subscribe(() => {
        const resumen = this.calcularResumen();
        this.resumenChanged.emit(resumen);
      });
  }

  onTogglePalmerinChange(index: number, checked: boolean): void {
    const menor = this.entradas.at(index).get('menor') as FormGroup;
    if (!menor) return;
    const idAbonadoControl = menor.get('id_abonado');
    const pinAbonadoControl = menor.get('pin_abonado');

    menor.reset({ toggle_palmerin: checked });

    if (checked) {
      idAbonadoControl?.setValidators([Validators.required]);
      pinAbonadoControl?.setValidators([Validators.required]);
    } else {
      idAbonadoControl?.clearValidators();
      pinAbonadoControl?.clearValidators();
      idAbonadoControl?.setErrors(null);
      pinAbonadoControl?.setErrors(null);
    }

    idAbonadoControl?.updateValueAndValidity({ emitEvent: false });
    pinAbonadoControl?.updateValueAndValidity({ emitEvent: false });

    if (checked) {
      menor.patchValue({
        nombre: '',
        apellidos: '',
        fecha_nacimiento: '',
        id_abonado: '',
        pin_abonado: '',
        check_abonado: false
      });
    } else {
      menor.patchValue({
        check_abonado: false
      });
    }
  }


  getPrecioAbonado(i: number): string {
    const menor = this.entradas.at(i).get('menor');
    if (!menor) return '';

    const base = this.ticketPrice ?? 0;
    const descuentoActivo = this.reservationService.porcentajeEntradaEnabledValue;
    const descuentoGlobal = this.reservationService.porcentajeEntradaValue ?? 0;
    const descuentoIndividual = Number(menor.get('porcentaje_descuento')?.value) || 0;
    const descuento = descuentoIndividual || descuentoGlobal;

    let precioFinal = this.ticketPricePalmerin ?? base;

    if (descuentoActivo && descuento > 0) {
      precioFinal = base * (1 - descuento / 100);
    }

    return precioFinal.toFixed(2);
  }


  get ticketPrice(): number | null {
    return this.reservationService.currentTicketPrice;
  }

  get ticketPricePalmerin(): number | null {
    return this.reservationService.currentTicketPricePalmerin;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.formulario) return;

    if (changes['numeroEntradas']) {
      const nuevoValor = changes['numeroEntradas'].currentValue;

      if (nuevoValor == null || nuevoValor === 0) return;
      if (this.entradas.length === nuevoValor) return;

      this.crearFormularios();
    }

    if (changes['compradorForm'] && !changes['compradorForm'].firstChange) {
      this.crearFormularios();
    }

  }


  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  get entradas(): FormArray {
    return this.formulario.get('entradas') as FormArray;
  }

  crearFormularios(): void {

    const prev = JSON.parse(JSON.stringify(this.entradas.value || []));

    while (this.entradas.length < this.numeroEntradas) {
      this.entradas.push(this.crearEntradaForm());
    }
    while (this.entradas.length > this.numeroEntradas) {
      this.entradas.removeAt(this.entradas.length - 1);
    }

    this.entradas.controls.forEach((ctrl, index) => {
      if (prev[index]) {
        ctrl.patchValue(prev[index], { emitEvent: false });
      }
    });
  }

crearEntradaForm(): FormGroup {
    return this.fb.group({
      responsable: this.fb.group({
        dni: ['', [Validators.required, dniValidator]],
        nombre: ['', Validators.required],
        apellidos: ['', Validators.required],
        email: ['', [Validators.required, Validators.email]],
        telefono: ['', [Validators.required, telefonoValidator]],
        domicilio: ['', Validators.required],
        codigoPostal: ['', [Validators.required, codigoPostalValidator]],
      }),
      menor: this.fb.group({
        nombre: ['', Validators.required],
        apellidos: ['', Validators.required],
        fecha_nacimiento: ['', Validators.required],
        id_abonado: [''],
        pin_abonado: [''],
        check_abonado: [false],
        toggle_palmerin: [false]
      })
    });
}

  copiarResponsableAnterior(index: number): void {
    if (index === 0) return;
    const anterior = this.entradas.at(index - 1).get('responsable')?.value;
    this.entradas.at(index).get('responsable')?.patchValue(anterior);
  }

  copiarCompradorComoResponsable(index: number): void {
      if (!this.compradorForm) return;

      const compradorFormValue = this.compradorForm.value;
      const tieneDatos = compradorFormValue.nombreComprador
        && compradorFormValue.apellidosComprador
        && compradorFormValue.dniComprador;

      if (!tieneDatos) return;

      const comprador = {
        dni: compradorFormValue.dniComprador,
        nombre: compradorFormValue.nombreComprador,
        apellidos: compradorFormValue.apellidosComprador,
        email: compradorFormValue.emailComprador,
        telefono: compradorFormValue.telefonoComprador,
        domicilio: compradorFormValue.domicilioComprador,
        codigoPostal: compradorFormValue.codigoPostalComprador
      };

      this.entradas.at(index).get('responsable')?.patchValue(comprador);
  }

  copiarCompradorComoResponsableEnTodos(): void {
      if (!this.compradorForm) return;

      const compradorFormValue = this.compradorForm.value;
      const tieneDatos = compradorFormValue.nombreComprador
        && compradorFormValue.apellidosComprador
        && compradorFormValue.dniComprador;

      if (!tieneDatos) return;

      const comprador = {
        dni: compradorFormValue.dniComprador,
        nombre: compradorFormValue.nombreComprador,
        apellidos: compradorFormValue.apellidosComprador,
        email: compradorFormValue.emailComprador,
        telefono: compradorFormValue.telefonoComprador,
        domicilio: compradorFormValue.domicilioComprador,
        codigoPostal: compradorFormValue.codigoPostalComprador
      };
      this.entradas.controls.forEach((entrada) => {
        entrada.get('responsable')?.patchValue(comprador);
      });
  }


  comprobarIdAbonado(index: number): void {
    const entradaGroup = this.entradas.at(index);
    const idControl = entradaGroup.get('menor.id_abonado');
    const idAbonado = idControl?.value;

    const pinControl = entradaGroup.get('menor.pin_abonado');
    const pinAbonado = pinControl?.value;

    const idDuplicado = this.entradas.controls.some((entrada, i) =>
      i !== index && entrada.get('menor.id_abonado')?.value === idAbonado
    );

    if (idDuplicado) {
      idControl?.setErrors({ duplicado: true });
    }

    const pinDuplicado = this.entradas.controls.some((entrada, i) =>
      i !== index && entrada.get('menor.pin_abonado')?.value === pinAbonado
    );

    if (pinDuplicado) {
      pinControl?.setErrors({ duplicado: true });
    }

    if (idDuplicado || pinDuplicado) {
      return;
    }

    idControl?.setErrors(null);
    pinControl?.setErrors(null);

    this.compraFotoService.checkPalmerin(idAbonado, pinAbonado).subscribe({
      next: data => {
        if (data) {
          idControl?.setErrors(null);
          pinControl?.setErrors(null);
          const menorGroup = entradaGroup.get('menor');
          menorGroup?.patchValue({
            nombre: data.name,
            apellidos: `${data.surname1} ${data.surname2}`,
            fecha_nacimiento: data.dob,
            check_abonado: true
          });
          this.validarEdadMenor(index);
        } else {
          console.warn('No se encontró el abonado');
          const menorGroup = entradaGroup.get('menor');
          menorGroup?.patchValue({
            check_abonado: false
          });
          idControl?.setErrors({ noEncontrado: true });
          pinControl?.setErrors({ noEncontrado: true });
        }
      },
      error: err => {
        console.error('Error comprobando el ID de abonado:', err);
        const menorGroup = entradaGroup.get('menor');
        menorGroup?.patchValue({
          check_abonado: false
        });
        idControl?.setErrors({ noEncontrado: true });
        pinControl?.setErrors({ noEncontrado: true });
      }
    });
  }

  private calcularResumen() {

    const empty = () => ({
      abonados: { count: 0, total: 0 },
      noAbonados: { count: 0, total: 0 },
      subtotal: 0,
      impuestos: 0,
      total: 0
    });

    if (!this.formulario || !this.ticketPrice) return empty();

    const base = this.ticketPrice;
    const descuentoActivo = this.reservationService.porcentajeEntradaEnabledValue;
    const descuentoGlobal = this.reservationService.porcentajeEntradaValue ?? 0;

    const { abonados, noAbonados } = this.entradas.controls.reduce(
      (acc, entrada) => {
        const menor = entrada.get('menor');
        if (!menor) return acc;

        const esAbonado = !!menor.get('check_abonado')?.value;
        const descuento = Number(menor.get('porcentaje_descuento')?.value) || descuentoGlobal;

        let precio = base;
        if (esAbonado) {
          precio = descuentoActivo && descuento > 0
            ? base * (1 - descuento / 100)
            : this.ticketPricePalmerin ?? base;

          acc.abonados.count++;
          acc.abonados.total += precio;
        } else {
          acc.noAbonados.count++;
          acc.noAbonados.total += base;
        }

        return acc;
      },
      { abonados: { count: 0, total: 0 }, noAbonados: { count: 0, total: 0 } }
    );

    const subtotal = abonados.total + noAbonados.total;
    const impuestos = 0;
    const total = subtotal + impuestos;

    return { abonados, noAbonados, subtotal, impuestos, total };
  }


  getIsPalmerin(index: number): boolean {
    return !!this.entradas.at(index).get(['menor', 'toggle_palmerin'])?.value;
  }

  onSubmit(): void {
  }

  getFechaNacimientoDate(index: number): Date | null {
    const value = this.entradas.at(index).get(['menor', 'fecha_nacimiento'])?.value;
    if (!value) return null;

    if (value instanceof Date) {
      return value;
    }

    if (typeof value === 'string') {
      const match = value.match(/^(\d{4})-(\d{2})-(\d{2})$/);
      if (match) {
        const year = Number(match[1]);
        const month = Number(match[2]) - 1;
        const day = Number(match[3]);
        return new Date(year, month, day);
      }

      const parsed = new Date(value);
      return Number.isNaN(parsed.getTime()) ? null : parsed;
    }

    return null;
  }

  onFechaNacimientoChange(index: number, event: MatDatepickerInputEvent<Date>): void {
    const control = this.entradas.at(index).get(['menor', 'fecha_nacimiento']);
    if (!control) return;

    const selectedDate = event.value;
    if (!selectedDate) {
      control.setValue('');
      return;
    }

    const year = selectedDate.getFullYear();
    const month = String(selectedDate.getMonth() + 1).padStart(2, '0');
    const day = String(selectedDate.getDate()).padStart(2, '0');
    control.setValue(`${year}-${month}-${day}`);

    this.validarEdadMenor(index);
}

private validarEdadMenor(index: number): void {
    const control = this.entradas.at(index).get(['menor', 'fecha_nacimiento']);
    if (!control || !control.value || !this.fechaPartido) {
      return;
    }

    const fechaNacimiento = new Date(control.value);
    const edad = this.calcularEdadEnFecha(fechaNacimiento, this.fechaPartido);

    const errors = { ...control.errors };
    if (edad < 0 || edad > 13) {
      control.setErrors({ ...errors, edadNoValida: true });
    } else {
      delete errors['edadNoValida'];
      control.setErrors(Object.keys(errors).length ? errors : null);
    }
    control.updateValueAndValidity();
}

private calcularEdadEnFecha(fechaNacimiento: Date, fechaReferencia: Date): number {
    let edad = fechaReferencia.getFullYear() - fechaNacimiento.getFullYear();
    const m = fechaReferencia.getMonth() - fechaNacimiento.getMonth();
    if (m < 0 || (m === 0 && fechaReferencia.getDate() < fechaNacimiento.getDate())) {
      edad--;
    }
    return edad;
}

edadNoValida(index: number): boolean {
  return !!this.entradas.at(index).get(['menor', 'fecha_nacimiento'])?.hasError('edadNoValida');
}

isFechaNacimientoInvalid(index: number): boolean {
  if (!this.submitClicked) return false;
  const control = this.entradas.at(index)?.get(['menor', 'fecha_nacimiento']);
  return !!control && control.invalid && (control.dirty || control.touched);
}

triggerValidation(): void {
  this.submitClicked = true;
  this.entradas.controls.forEach((entrada) => {
    const controls = [
      entrada.get('menor.fecha_nacimiento'),
      entrada.get('menor.nombre'),
      entrada.get('menor.apellidos'),
      entrada.get('responsable.dni'),
      entrada.get('responsable.nombre'),
      entrada.get('responsable.apellidos'),
      entrada.get('responsable.email'),
      entrada.get('responsable.telefono'),
      entrada.get('responsable.domicilio'),
      entrada.get('responsable.codigoPostal'),
    ];
    controls.forEach(c => {
      if (c) {
        c.markAsTouched();
        c.markAsDirty();
      }
    });
  });
}

}
